/**
 * Shared constants used across the application
 */

// Block interaction constants
export const BLOCK_INTERACTION_RANGE = 50 // Maximum distance for block placement/removal/highlight

// Block coordinate bounds (Three.js units)
// Note: These are the bounds for Three.js coordinates before scaling.
// When exporting, coordinates are scaled by 2x to Roblox studs.
// Scaled bounds: X/Z: -1000 to 1000, Y: 0 to 1000
export const BLOCK_X_MIN = -500
export const BLOCK_X_MAX = 500
export const BLOCK_Z_MIN = -500
export const BLOCK_Z_MAX = 500
export const BLOCK_Y_MIN = 0
export const BLOCK_Y_MAX = 500

// Scaled coordinate bounds (Roblox studs) - used for export validation
export const SCALED_BLOCK_X_MIN = -1000
export const SCALED_BLOCK_X_MAX = 1000
export const SCALED_BLOCK_Z_MIN = -1000
export const SCALED_BLOCK_Z_MAX = 1000
export const SCALED_BLOCK_Y_MIN = 0
export const SCALED_BLOCK_Y_MAX = 1000

// Block limit
export const MAX_USER_BLOCKS = 10000 // Maximum user-placed blocks (ground excluded)

// Color hex values for solid color blocks (removed indigo, moved violet to slot 6, added brown to slot 7)
export const COLOR_RED = '#FF0000'
export const COLOR_ORANGE = '#FFA500'
export const COLOR_YELLOW = '#FFFF00'
export const COLOR_GREEN = '#00FF00'
export const COLOR_BLUE = '#0000FF'
export const COLOR_VIOLET = '#8B00FF'
export const COLOR_BROWN = '#8B4513'
export const COLOR_WHITE = '#FFFFFF'
export const COLOR_GRAY = '#808080'
export const COLOR_BLACK = '#000000'

